import '../App.css';
import Section from '../components/Section';
import Headery from '../components/Headery';
import {
  React,
  useState
} from 'react';
import DefaultElement from '../components/DefaultElement';
import Main from '../components/Main';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Base from './Base';
import Hello from './Hello';
import Rainbow from './Rainbox';
import AltIFrame from './AltIframe';
import Crash from './Crash';
import Eva from './Eva';
import Eva2 from './Eva2';
import Impress from './Impress';
import AppV2 from './AppV2';
import Imprint from './Imprint';
import DesignPortfolio from './DesignPortfolio';

function App() {
  


  return <BrowserRouter>
    <Routes>
      <Route index element={<AppV2></AppV2>}></Route>
      <Route path="/imprint" element={<Imprint></Imprint>}></Route>
      <Route path="/design" element={<DesignPortfolio></DesignPortfolio>}></Route>
      <Route path="/v1" element={<Base/>}/>
      <Route path="/v1/hello" element={<Hello></Hello>}/>
      <Route path="/v1/rainbow" element={<Rainbow></Rainbow>}/>
      <Route path="/v0" element={<AltIFrame></AltIFrame>}/>
      <Route path="/v1/crash" element={<Crash></Crash>}/>
      <Route path="/v1/impress" element={<Impress></Impress>}></Route>
      <Route path="/v1/eva" element={<Eva></Eva>}></Route>
      <Route path="/v1/mytruelove" element={<Eva2></Eva2>}></Route>
      <Route path="*" element={<DefaultElement/>}/>
    </Routes>
  </BrowserRouter>;
}

export default App;
